import { CIMSTag } from 'components/CIMSTag'
import { CIMSTagProps } from 'components/CIMSTag/types'

export const Tag: React.FC<Pick<CIMSTagProps, 'tooltip'>> = ({
  tooltip,
  children,
}) => (
  <CIMSTag
    style={{
      cursor: 'pointer',
      display: 'inline-flex',
      alignItems: 'center',
      height: 32,
      margin: 0,
    }}
    tooltip={tooltip}
  >
    <span style={{ fontSize: 14 }}>{children}</span>
  </CIMSTag>
)

export default Tag
